import Swal from 'sweetalert2';
import { DatePipe } from "@/functions/dateformat";

let mostrarMensaje = (titulo, mensaje, icono, showBoton = false, timer = 2000, foco = '') => {
  if (foco !== '') {
    document.getElementById(foco).focus();
  }
  Swal.fire({
    title: titulo,
    text: mensaje,
    icon: icono,
    showConfirmButton: showBoton,
    timer: timer
  })
}

let mostrarMensajeExito = (mensaje) => {
  mostrarMensaje('Éxito', mensaje,'success');
}
let mostrarMensajeExitoConTitulo = (titulo,mensaje) => {
  mostrarMensaje(titulo, mensaje,'success');
}
let mostrarMensajeAdvertencia = (mensaje) => {
  mostrarMensaje('Advertencia', mensaje,'warning', true, false);
}
let mostrarMensajeInfoConTitulo = (titulo,mensaje) => {
  mostrarMensaje(titulo, mensaje,'info', true, false);
}
let mostrarMensajeError = (mensaje) => {
  mostrarMensaje('Error', mensaje,'error', true, false);
}
let mostrarMensajeErrorConTitulo = (titulo,mensaje) => {
  mostrarMensaje(titulo, mensaje,'error', true, false);
}

let formatFecha = (value, format) => {
  return DatePipe.transform(value,format);
} 

export default {
  mostrarMensaje,
  mostrarMensajeExito,
  mostrarMensajeExitoConTitulo,
  mostrarMensajeAdvertencia,
  mostrarMensajeError,
  formatFecha,
  mostrarMensajeInfoConTitulo,
  mostrarMensajeErrorConTitulo
}